import * as Sentry from '@sentry/react';
import config from '../config';

const analytics = {
	init: () => {
		try {
			Sentry.init({
				dsn: config.SENTRY_DSN,
				integrations: [
					Sentry.browserTracingIntegration(),
				],
				tracesSampleRate: 1.0,
				tracePropagationTargets: ['localhost', 'https://whispi.io'],
			});
		}
		catch (e) {
			console.error('[ANALYTICS ERROR] Failed to initialize Sentry', e);
		}
	},
};

export default analytics;
